// extracted by mini-css-extract-plugin
export var darkMode = "_u-0";